import { Link, useLocation } from 'react-router-dom';
import './Breadcrumbs.css';

// Route name mapping
const routeNames = {
  dashboard: 'Dashboard',
  products: 'Products',
  new: 'New',
  edit: 'Edit',
  orders: 'Orders',
  customers: 'Customers',
  reviews: 'Reviews',
  content: 'Content',
  media: 'Media Library',
  pages: 'Pages',
  analytics: 'Analytics',
  settings: 'Settings',
  integrations: 'Integrations',
  users: 'Users',
};

function Breadcrumbs() {
  const location = useLocation();
  const pathnames = location.pathname.split('/').filter((x) => x);

  // Don't show breadcrumbs on root or if only one level
  if (pathnames.length <= 1) {
    return (
      <nav className="breadcrumbs" aria-label="Breadcrumb">
        <ol className="breadcrumb-list">
          <li className="breadcrumb-item">
            <span className="breadcrumb-current">
              {routeNames[pathnames[0]] || 'Dashboard'}
            </span>
          </li>
        </ol>
      </nav>
    );
  }

  return (
    <nav className="breadcrumbs" aria-label="Breadcrumb">
      <ol className="breadcrumb-list">
        {pathnames.map((name, index) => {
          const routeTo = `/${pathnames.slice(0, index + 1).join('/')}`;
          const isLast = index === pathnames.length - 1;

          // Check if the name is likely an ID (UUID or numeric)
          const isId = /^[0-9a-f-]{8,}$/i.test(name) || /^\d+$/.test(name);
          const displayName = isId ? 'Details' : (routeNames[name] || name);

          return (
            <li key={routeTo} className="breadcrumb-item">
              {!isLast ? (
                <>
                  <Link to={routeTo} className="breadcrumb-link">
                    {displayName}
                  </Link>
                  <span className="breadcrumb-separator" aria-hidden="true">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" d="M8.25 4.5l7.5 7.5-7.5 7.5" />
                    </svg>
                  </span>
                </>
              ) : (
                <span className="breadcrumb-current">{displayName}</span>
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
}

export default Breadcrumbs;
